import React from 'react';
import styles from "../ProductItem/ProductItem.module.css";
import Button from "../Button";
import PropTypes from 'prop-types'; 

export const ProductItem = ({ logo, description, onClick, img, color, hasFreeTrial }) => {
  return (
    <div className={styles.productComponent}>
      <div className={styles.logoContainer}>
        <img src={logo} alt="Logo" className= {styles.logoContainerImg} />
      </div>
      <div className={styles.descriptionContainer}>
        <p>{description}</p>
      </div>
      <div className={styles.buttonContainer}>
         <Button label="LEARN MORE" onClick={onClick} color={color}/> 
      </div>
      {hasFreeTrial && (
        <div className={styles.freeTrialContainer}>
          <p>Try it Free for One Month</p>
        </div>
      )}
      <div className={styles.imageContainer}>
        <img src={img} alt="Product1" />
      </div>
    </div>
  );
};

ProductItem.propTypes = {
  logo: PropTypes.string.isRequired, 
  description: PropTypes.string.isRequired, 
  onClick: PropTypes.func.isRequired, 
  img: PropTypes.string.isRequired,
  color: PropTypes.string, 
  hasFreeTrial: PropTypes.bool 
};